function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.6 24.2h192.5v327.5H73.6z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(7.689 289.664)"
}, "20,000 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(43.308 351.683)"
}, "0 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(6.428 224.398)"
}, "40,000 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(7.104 159.358)"
}, "60,000 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(6.727 93.543)"
}, "80,000 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(1.722 34.7)"
}, "100,000 $"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(63.957 380.435)"
}, "\u201809"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(115.64 380.435)"
}, "\u201811"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(162.433 380.435)"
}, "\u201813"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(210.534 380.435)"
}, "\u201815"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(258.498 380.435)"
}, "\u201817"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M97.7 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M121.7 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M145.8 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M169.8 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M193.9 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M217.9 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M242 24.2v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.6 220.7h192.6"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.6 286.2h192.6"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.6 155.2h192.6"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.6 89.7h192.6"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(1.722 12.981)"
}, "Annual Median Family Income"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Labels",
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 8
}, React.createElement("text", {
  transform: "translate(272.904 42.122)"
}, "Asian"), React.createElement("text", {
  transform: "translate(272.905 63.819)"
}, "White"), React.createElement("text", {
  transform: "translate(272.904 207)"
}, "Other"), React.createElement("text", {
  transform: "translate(272.904 195.999)"
}, "Hisp."), React.createElement("text", {
  transform: "translate(272.904 182.999)"
}, "Black"), React.createElement("text", {
  transform: "translate(274.311 132.702)"
}, "All"));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Lines",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round"
}, React.createElement("path", {
  strokeWidth: 2.867,
  d: "M73.7 228.7l24.1-4.5 24-4.1 24.1-2.4 24-2.1 24-3.1 24.1-3 24-5.7 24.1-7.7"
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M73.7 106l24.1-4.4 24-8.1 24.1-3 24-2.5 24-3.5 24.1-3.7 24-7.4 24.1-10.9",
  opacity: 0.6
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M73.7 230.5l24.1-2 24-3.4 24.1.1 24-1.4 24-3 24.1-3.9 24-5.1 24.1-7.5",
  opacity: 0.6
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M73.7 106.1l24.1-4.1 24-10.2 24.1-7.3 24-3.7 24-9.5 24.1-6 24-11.4 24.1-12.5"
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M73.7 216l24.1-7 24-3.8 24.1-2.4h24l24-4.3 24.1-1.8 24-6.3 24.1-8.5",
  opacity: 0.6
}), React.createElement("path", {
  strokeDasharray: "3,6",
  d: "M73.7 166.1l24.1-4.8 24-6.2 24.1-2 24-1.5 24-2.9 24.1-2.5 24-6.1 24.1-9.1"
}));

var SvgS4MobileColors = function SvgS4MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "congestion",
    x: 0,
    y: 0,
    viewBox: "0 0 300 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9ImNvbmdlc3Rpb24iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMDAgNDAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzhCOTNDNDt9Cgkuc3Qxe2ZpbGw6I0ZGRkZGRjt9Cgkuc3Qye2ZvbnQtZmFtaWx5OidNb250c2VycmF0LVJlZ3VsYXInO30KCS5zdDN7Zm9udC1zaXplOjEzcHg7fQoJLnN0NHtmb250LWZhbWlseTonTW9udHNlcnJhdC1Cb2xkJzt9Cgkuc3Q1e2ZvbnQtc2l6ZTo4cHg7fQoJLnN0NntmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIuODY3O3N0cm9rZS1saW5lY2FwOnJvdW5kO30KCS5zdDd7b3BhY2l0eTowLjY7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS13aWR0aDoyLjg2NztzdHJva2UtbGluZWNhcDpyb3VuZDtlbmFibGUtYmFja2dyb3VuZDpuZXcgICAgO30KCS5zdDh7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1kYXNoYXJyYXk6Myw2O30KPC9zdHlsZT4KPGcgaWQ9IkdyaWRfMV8iPgoJPHJlY3QgeD0iNzMuNiIgeT0iMjQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjE5Mi41IiBoZWlnaHQ9IjMyNy41Ii8+Cgk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDcuNjg4OCAyODkuNjY0MykiIGNsYXNzPSJzdDEgc3QyIHN0MyI+MjAsMDAwICQ8L3RleHQ+Cgk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDQzLjMwODQgMzUxLjY4MjcpIiBjbGFzcz0ic3QxIHN0MiBzdDMiPjAgJDwvdGV4dD4KCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgNi40MjgxIDIyNC4zOTgyKSIgY2xhc3M9InN0MSBzdDIgc3QzIj40MCwwMDAgJDwvdGV4dD4KCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgNy4xMDM5IDE1OS4zNTc5KSIgY2xhc3M9InN0MSBzdDIgc3QzIj42MCwwMDAgJDwvdGV4dD4KCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgNi43MjcgOTMuNTQyNSkiIGNsYXNzPSJzdDEgc3QyIHN0MyI+ODAsMDAwICQ8L3RleHQ+Cgk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDEuNzIyMSAzNC43MDAxKSIgY2xhc3M9InN0MSBzdDIgc3QzIj4xMDAsMDAwICQ8L3RleHQ+Cgk8Zz4KCQk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDYzLjk1NjkgMzgwLjQzNTIpIiBjbGFzcz0ic3QxIHN0MiBzdDMiPuKAmDA5PC90ZXh0PgoJPC9nPgoJPGc+CgkJPHRleHQgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAxMTUuNjM5MSAzODAuNDM1MikiIGNsYXNzPSJzdDEgc3QyIHN0MyI+4oCYMTE8L3RleHQ+Cgk8L2c+Cgk8Zz4KCQk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDE2Mi40MzMyIDM4MC40MzUyKSIgY2xhc3M9InN0MSBzdDIgc3QzIj7igJgxMzwvdGV4dD4KCTwvZz4KCTxnPgoJCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgMjEwLjUzNCAzODAuNDM1MikiIGNsYXNzPSJzdDEgc3QyIHN0MyI+4oCYMTU8L3RleHQ+Cgk8L2c+Cgk8Zz4KCQk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDI1OC40OTggMzgwLjQzNTIpIiBjbGFzcz0ic3QxIHN0MiBzdDMiPuKAmDE3PC90ZXh0PgoJPC9nPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9Ijk3LjciIHkxPSIyNC4yIiB4Mj0iOTcuNyIgeTI9IjM1MS43Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMTIxLjciIHkxPSIyNC4yIiB4Mj0iMTIxLjciIHkyPSIzNTEuNyIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjE0NS44IiB5MT0iMjQuMiIgeDI9IjE0NS44IiB5Mj0iMzUxLjciLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIxNjkuOCIgeTE9IjI0LjIiIHgyPSIxNjkuOCIgeTI9IjM1MS43Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMTkzLjkiIHkxPSIyNC4yIiB4Mj0iMTkzLjkiIHkyPSIzNTEuNyIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjIxNy45IiB5MT0iMjQuMiIgeDI9IjIxNy45IiB5Mj0iMzUxLjciLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIyNDIiIHkxPSIyNC4yIiB4Mj0iMjQyIiB5Mj0iMzUxLjciLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI3My42IiB5MT0iMjIwLjciIHgyPSIyNjYuMiIgeTI9IjIyMC43Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iNzMuNiIgeTE9IjI4Ni4yIiB4Mj0iMjY2LjIiIHkyPSIyODYuMiIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjczLjYiIHkxPSIxNTUuMiIgeDI9IjI2Ni4yIiB5Mj0iMTU1LjIiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI3My42IiB5MT0iODkuNyIgeDI9IjI2Ni4yIiB5Mj0iODkuNyIvPgoJPHRleHQgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAxLjcyMjIgMTIuOTgxMikiIGNsYXNzPSJzdDEgc3Q0IHN0MyI+QW5udWFsIE1lZGlhbiBGYW1pbHkgSW5jb21lPC90ZXh0Pgo8L2c+CjxnIGlkPSJMYWJlbHMiPgoJPHRleHQgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAyNzIuOTA0MiA0Mi4xMjE2KSIgY2xhc3M9InN0MSBzdDQgc3Q1Ij5Bc2lhbjwvdGV4dD4KCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgMjcyLjkwNDcgNjMuODE4OCkiIGNsYXNzPSJzdDEgc3Q0IHN0NSI+V2hpdGU8L3RleHQ+Cgk8Zz4KCQk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDI3Mi45MDQyIDIwNi45OTkxKSIgY2xhc3M9InN0MSBzdDQgc3Q1Ij5PdGhlcjwvdGV4dD4KCTwvZz4KCTxnPgoJCTx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgMjcyLjkwNDIgMTk1Ljk5ODkpIiBjbGFzcz0ic3QxIHN0NCBzdDUiPkhpc3AuPC90ZXh0PgoJPC9nPgoJPGc+CgkJPHRleHQgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAyNzIuOTA0MiAxODIuOTk4NykiIGNsYXNzPSJzdDEgc3Q0IHN0NSI+QmxhY2s8L3RleHQ+Cgk8L2c+Cgk8Zz4KCQk8dGV4dCB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAxIDI3NC4zMTE0IDEzMi43MDIpIiBjbGFzcz0ic3QxIHN0NCBzdDUiPkFsbDwvdGV4dD4KCTwvZz4KPC9nPgo8ZyBpZD0iTGluZXMiPgoJPHBvbHlsaW5lIGNsYXNzPSJzdDYiIHBvaW50cz0iNzMuNywyMjguNyA5Ny44LDIyNC4yIDEyMS44LDIyMC4xIDE0NS45LDIxNy43IDE2OS45LDIxNS42IDE5My45LDIxMi41IDIxOCwyMDkuNSAyNDIsMjAzLjggCgkJMjY2LjEsMTk2LjEgCSIvPgoJPHBvbHlsaW5lIGNsYXNzPSJzdDciIHBvaW50cz0iNzMuNywxMDYgOTcuOCwxMDEuNiAxMjEuOCw5My41IDE0NS45LDkwLjUgMTY5LjksODggMTkzLjksODQuNSAyMTgsODAuOCAyNDIsNzMuNCAyNjYuMSw2Mi41IAkiLz4KCTxwb2x5bGluZSBjbGFzcz0ic3Q3IiBwb2ludHM9IjczLjcsMjMwLjUgOTcuOCwyMjguNSAxMjEuOCwyMjUuMSAxNDUuOSwyMjUuMiAxNjkuOSwyMjMuOCAxOTMuOSwyMjAuOCAyMTgsMjE2LjkgMjQyLDIxMS44IAoJCTI2Ni4xLDIwNC4zIAkiLz4KCTxwb2x5bGluZSBjbGFzcz0ic3Q2IiBwb2ludHM9IjczLjcsMTA2LjEgOTcuOCwxMDIgMTIxLjgsOTEuOCAxNDUuOSw4NC41IDE2OS45LDgwLjggMTkzLjksNzEuMyAyMTgsNjUuMyAyNDIsNTMuOSAyNjYuMSw0MS40IAkiLz4KCTxwb2x5bGluZSBjbGFzcz0ic3Q3IiBwb2ludHM9IjczLjcsMjE2IDk3LjgsMjA5IDEyMS44LDIwNS4yIDE0NS45LDIwMi44IDE2OS45LDIwMi44IDE5My45LDE5OC41IDIxOCwxOTYuNyAyNDIsMTkwLjQgCgkJMjY2LjEsMTgxLjkgCSIvPgoJPHBvbHlsaW5lIGNsYXNzPSJzdDgiIHBvaW50cz0iNzMuNywxNjYuMSA5Ny44LDE2MS4zIDEyMS44LDE1NS4xIDE0NS45LDE1My4xIDE2OS45LDE1MS42IDE5My45LDE0OC43IDIxOCwxNDYuMiAyNDIsMTQwLjEgCgkJMjY2LjEsMTMxIAkiLz4KPC9nPgo8L3N2Zz4K";
export { SvgS4MobileColors as ReactComponent };